export default [
  {
    list: [
      {
        subTitle: '순단없는 전원 공급 설비',
        desc:
          '데이터센터는 정전, 지진, 침수 등 예측할 수 없는 상황에 늘 대비해야 합니다. 데이터센터 각은 외부 변전소로 공급되는 전력 경로 및 내부 시스템의 이중화 구성으로 어떤 영향에도 중단 없는 서비스를 제공합니다.',
      },
      {
        subTitle: '24시간*365일 안전하고 강화된 물리보안 시스템',
        desc:
          '데이터센터 각은 물리보안 시설로서 최고 단계의 보안시스템을 적용하여 24시간 *365일 실시간으로 모니터링하고 출입을 통제하고 있습니다. 또한, 서비스와 시스템에 대한 각 종 외부 공격에 대비하여 서버 보안 진단, 실사 백업, DDcS 공격 대응 시스템 등이 갖춰져 있습니다.',
      },
      {
        subTitle: '에너지 효율 및 안정성이 강화된 냉방 시스템 개발, 적용',
        desc:
          '데이터센터 각은 1년 중 80~90% 이상의 기간동안 자연 외기를 활용하여 서버실을 냉방 할 수 있는 시스템을 개발하여 글로벌 Top 수준의 고 에너지 효율의 친환경 데이터를 구축, 운영하고 있습니다.<br /><br />전원, 기계 등 중요 인프라 시설과 설비는 이중화 & 이원화로 구성하여 어떠한 비상 상황에서도 안정적인 서비스를 운영 할 수 있는 환경이 갖춰져 있습니다.',
      },
      {
        subTitle: '안정적이고 효율적인 운영을 위한 최적화 자동제어 시스템',
        desc: '데이터센터 각은 통합 모니터링 시스템을 통해 24시간 * 365일 최적의 환경에서 모든 설비를 모니터링하고 효율적으로 데이터를 관리하고 있습니다.',
      },
      {
        subTitle: '자연을 에너지로 만드는 기술',
        desc: '친환경 데이터센터 각은 주변 자연환경을 적극적으로 활용하여 에너지를 창출함으로써 지속 가능한 운영을 실천합니다.',
      },
      {
        subTitle: '친환경 가치를 높이는 자원 재활용 시스템',
        desc: '데이터센터 각은 자원의 재활용을 통해 친환경 가치를 높여갑니다.',
      },
    ],
  },
  {
    list: [
      {
        subTitle: '순단없는 전원 공급 설비',
        desc:
          '데이터센터는 정전, 지진, 침수 등 예측할 수 없는 상황에 늘 대비해야 합니다. 데이터센터 각은 외부 변전소로 공급되는 전력 경로 및 내부 시스템의 이중화 구성으로 어떤 영향에도 중단 없는 서비스를 제공합니다.',
        list: [
          {
            title: '이중 전력 공급',
            text:
              '데이터센터 각은 안정적인 전원 공급을 위해 한국 전력 변전소로부터 이원화 된 경로와 이중화 라인으로 전력을 공급 받습니다.<br/><br/>각 세종으로 인입되는 초고압 154kV 전원 라인은 이원화 된 지중 경로로 구성되어 각 세종 전기실까지 안전하게 인입되어 있으며, 단계별 증설/확장이 용이하도록 모듈 형태로 구성, 운영하고 있습니다.',
            name: '',
            img: '/img/tech/safety-1-1.jpg',
          },
          {
            title: '무정전 전원 공급장치',
            text:
              'UPS는 전력 공급이 중단되었을 때 약 15~20분동안 전력을 공급해줍니다.<br class="hidden-sm-down"><br class="hidden-sm-down">각 춘천은 Dynamic UPS, 각 세종은 Static UPS로 각각 구성되어 전력 공급 중단이나 순간정전 발생 시 UPS에 연결된 인덕션커플링(춘천) 또는 배터리(세종)로 비상 발전기 가동 전까지 일정 시간 백업 전력을 순단없이 안정적으로 공급합니다.',
            name: 'UPS(Uninterruptible Power Supply : 무정전 전원공급 장치)',
            img: '/img/tech/safety-1-2.jpg',
          },
          {
            title: '백업의 백업,<br/>STS',
            text:
              'STS는 서버실 랙(Rack) 전원으로 공급되는 UPS 전원의 정전 발생 시 주 전원에서 예비 전원으로 순단 없이 전원을 전환하는 스위치입니다.<br class="hidden-sm-down"><br class="hidden-sm-down"> 랙(Rack)으로 공급되는 UPS 전력의 공급 품질이 저하(정전, Fault, 순단 등)되면, 자동적으로 주 전원에서 예비 전원으로 전환하여 어떤 외부 영향과 변화에서도 순단 없이 안정적으로 전원 공급을 가능하게 합니다.',
            name: 'STS(Static Transfer Switch)<br/>무순단 소스 절체 스위치',
            img: '/img/tech/safety-1-3.jpg',
          },
        ],
      },
      {
        subTitle: '24시간*365일 안전하고 강화된 물리보안 시스템',
        desc:
          '데이터센터 각은 물리보안 시설로서 최고 단계의 보안시스템을 적용하여 24시간 *365일 실시간으로 모니터링하고 출입을 통제하고 있습니다. 또한, 서비스와 시스템에 대한 각 종 외부 공격에 대비하여 서버 보안 진단, 실사 백업, DDcS 공격 대응 시스템 등이 갖춰져 있습니다.',
        list: [
          {
            title: '건물 침입감지 시스템',
            text:
              '데이터센터 각은 비허가 접근을 감지하는 침입 감지 시설을 구축, 운영하고 있습니다.<br class="hidden-sm-down"><br class="hidden-sm-down">각 춘천은 진동 감지 센서와 적외선 감지 센서를 외곽 펜스에 설치하여 비인가자 침입을 감지, 대응 할 수 있도록 부지 전체를 24시간*365일 상시적으로 모니터링 하고 있습니다.<br/>각 세종의 경우, 진동 감지 센터 케이블과 사각 지대 없이 설치된 CCTV의 영상 분석 시스템을 통해 비인가자의 침입을 감지, 차단하고 있습니다.',
            name: '',
            img: '/img/tech/safety-2-1.jpg',
          },
          {
            title: '철저한 출입관리',
            text:
              '데이터센터 각은 네이버클라우드 자체 개발 솔루션인 데이터센터 출입 관리 전용 시스템 (VMS)을 적용하여 모든 방문자의 출입을 관리하고 기록하고 있습니다. 출입 등록 시 보안 구역에 따라 단계적으로 출입 권한을 부여하고, 추가 인증이 필요한 구간에는 카드리더기, 생체 인식, Man-trap 등 보다 강화된 물리보안 시스템을 적용하여 운영하고 있습니다.',
            name: 'VMS(Visitor Manager System)',
            img: '/img/tech/safety-2-2.jpg',
          },
          {
            title: 'DDoS 공격 감지 및 차단',
            text:
              '데이터센터 각은 외부 다양한 DDoS 공격 징후를 감지하기 위해 24시간*365일 실시간 모니터링하여 감지 즉시 전담반을 구성합니다. 수집한 공격 정보를 바탕으로 꾸준히 시스템을 개선하여 효율적인 대응 시스템을 구축, 운영하고 있습니다.',
            name: '',
            img: '/img/tech/safety-2-3.jpg',
          },
        ],
      },
    ],
  },
  {
    list: [
      {
        subTitle: '에너지 효율 및 안정성이 강화된 냉방 시스템 개발, 적용',
        desc:
          '데이터센터 각은 1년 중 80~90% 이상의 기간동안 자연 외기를 활용하여 서버실을 냉방 할 수 있는 시스템을 개발하여 글로벌 Top 수준의 고 에너지 효율의 친환경 데이터를 구축, 운영하고 있습니다.<br /><br />전원, 기계 등 중요 인프라 시설과 설비는 이중화 & 이원화로 구성하여 어떠한 비상 상황에서도 안정적인 서비스를 운영 할 수 있는 환경이 갖춰져 있습니다.',
        list: [
          {
            title: '독보적인 PUE 지수',
            text:
              '데이터센터 전력 효율을 나타내는 PUE지수는 그 값이 1에 가까울수록 효율적인 데이터센터임을 의미합니다.<br/><br/>데이터센터 각은 연평균 1.1x PUE로 높은 에너지 효율을 유지하고 있습니다.',
            name: 'PUE(Power Usage Effectiveness)<br/>총 소비 전력량을 IT 장비 소비 전력량으로 나눈 값',
            img: '/img/tech/performance-1-1.jpg',
          },
          {
            title: '하이브리드 공조 시스템,<br/>NAMU',
            text:
              '데이터센터 각은 독자적인 서버실 공조시스템, NAMU(NAVER Air Membrane Unit)를 개발,운영하고 있습니다.<br class="hidden-sm-down"><br class="hidden-sm-down">직접 외기 냉방을 적극적으로 활용하는 1,2세대 NAMU에 이어, 간접 외기 냉방과 직접 외기 냉방을 선택적으로 사용 가능한 하이브리드 공조시스템 NAMU3가 각 세종에 개발,적용되어 있습니다. 이를 통해 365일 자연 외기와 열원을 최대한 활용한, 안정적이고 효율적인 운영과 함께 에너지를 한층 더 효과적으로 절감하고 있습니다.',
            name: '',
            img: '/img/tech/performance-1-2.jpg',
          },
          {
            title: '냉방 설비 계통의 이중화 &<br/>이원화 설계 및 구성',
            text:
              '심야 전기를 이용한 수축열 시스템, 외기를 활용하는 프리쿨링 시스템 등을 복합 적용하여 최소한의 에너지로 운영 효율성을 극대화하고, 안정적인 서버실 냉방 운영이 가능하도록 모든 인프라 시설을 최소 n+1(예비) 이상으로 구성하였습니다.',
            name: '',
            img: '/img/tech/performance-1-3.jpg',
          },
        ],
      },
      {
        subTitle: '안정적이고 효율적인 운영을 위한 최적화 자동제어 시스템',
        desc: '데이터센터 각은 통합 모니터링 시스템을 통해 24시간 * 365일 최적의 환경에서 모든 설비를 모니터링하고 효율적으로 데이터를 관리하고 있습니다.',
        list: [
          {
            title: '자체 인프라 관리 시스템,<br/>DCIM',
            text:
              '건물의 각종 에너지 사용량과 전력 사용 효율(PUE)을 최적화 하기 위해 전력 사용 트렌드를 최소 1분 단위로 분석, 관리하고 모든 인프라 설비를 실시간 모니터링할 수 있는 데이터센터 인프라 관리 시스템(DCIM)을 구축 운영하고 있습니다.',
            name: '',
            img: '/img/tech/performance-2-1.jpg',
          },
          {
            title: '표준화된 실시간 장애 관리 시스템,<br/>TTS',
            text: '사용자가 겪는 서비스 장애를 다섯 단계로 나누어 처리하는 자체 개발 TTS 시스템을 활용하여 문제상황을 빠르게 분석하고 정확하게 해결합니다.',
            name: 'TTS(Trouble Ticket System)',
            img: '/img/tech/performance-2-2.jpg',
          },
          {
            title: '통합모니터링시스템',
            text:
              '데이터센터 각은 모든 설비의 운영 상태, 에너지 사용현황, 각종 알람을 한눈에 모니터링할 수 있는 통합모니터링 시스템을 통해 에너지 효율을 향상시키고 각종 이슈 (고장, unit Fault, 오류 등)에 대해 신속히 대응할 수 있습니다.',
            name: '',
            img: '/img/tech/performance-2-3.jpg',
          },
        ],
      },
    ],
  },
  {
    list: [
      {
        subTitle: '자연을 에너지로 만드는 기술',
        desc: '친환경 데이터센터 각은 주변 자연환경을 적극적으로 활용하여 에너지를 창출함으로써 지속 가능한 운영을 실천합니다.',
        list: [
          {
            title: '태양광 발전 시설',
            text:
              '데이터센터 각은 건물 옥상 및 옥외 유휴공간에 태양광 발전 시설을 설치하여 건물 내/외 조명과 난방 에너지로 활용하고 있습니다. 이를 통해 연간 약 200MWh의 전력을 절감하고, 탄소 배출을 매년 약 92톤정도 감축하고 있습니다.',
            name: '',
            img: '/img/tech/eco-1-1.jpg',
          },
          {
            title: '지열 시스템',
            text:
              '데이터센터 각 세종은 지하 220m까지 천공(240개)하여 수집한 지중열을 이용하여 본관의 냉,난방 열원으로 활용합니다.<br/>일 년 내내 15~20도 내외의 일정한 온도로 유지되는 지중열을 이용하여, 여름에는 시원하고, 겨울에는 따뜻한 친환경 자연 에너지를 효율적으로 활용하고 있습니다.',
            name: '',
            img: '/img/tech/eco-1-2.jpg',
          },
        ],
      },
      {
        subTitle: '친환경 가치를 높이는 자원 재활용 시스템',
        desc: '데이터센터 각은 자원의 재활용을 통해 친환경 가치를 높여갑니다.',
        list: [
          {
            title: '폐열 회수 장치',
            text:
              '데이터센터 각 세종은 온도 제어가 가능한 폐열 회수 시스템을 적용하여 서버실에서 배출되는 폐열 에너지를 다양하게 활용, 운영하고 있습니다.<br/><br/>서버에서 배출되는 폐열은 사계절 동안 본관의 난방 및 온수에 이용하며, 겨울철 센터의 내부 순환도로가 결빙 되지 않도록 스노우멜팅 시스템에 적용하여 전기 에너지 사용량을 절감, 운영하고 있습니다.',
            name: '',
            img: '/img/tech/eco-2-1.jpg',
          },
          {
            title: '스노우 멜팅 시스템',
            text: '서버에서 발생한 폐열로 데워진 물을 도로 밑 온수관으로 흘려 보내는 부동온수 방식의 스노우멜팅 시스템을 적용하여 겨울철 순환도로 및 경사도로의 결빙을 방지하고 쌓인 눈을 녹입니다.',
            name: '',
            img: '/img/tech/eco-2-2.jpg',
          },
          {
            title: '물 재활용 시스템',
            text:
              '우천 시 지붕에 모인 빗물은 정화 후 냉각탑 보급수 및 조경 용수로 재활용하고, 중수시스템을 통해 세면기/샤워실에서 회수된 물을 수처리한 뒤 양변기에 사용하는 물로 재활용하여 수자원 절감에도 노력하고 있습니다.<br/><br/>이러한 물 재활용 시스템을 통해 전체 물 사용량의 34%를 절감합니다.',
            name: '',
            img: '/img/tech/eco-2-3.jpg',
          },
        ],
      },
    ],
  },
  {
    list: [
      {
        title: '데이터 이중화',
        body:
          '사용자의 데이터를 안전하게 보관/운영하기 위하여 자체적으로 개발한 데이터 저장 시스템을 이용하여 서버에 저장되는 데이터를 이중/삼중으로 복제하고 이를 또한 데이터센터 내에 여러 서버에 분산 저장함으로써 예기치 못한 IT 장비의 고장 및 기타 장애 상황에서도 안정적으로 서비스를 제공할 수 있습니다.',
        name: '',
        img: '/img/tech/ft-1.jpg',
        bg: '/img/tech/ft-1-m.jpg',
      },
      {
        title: '재해 복구 서비스 (DR)',
        body:
          '지진, 화재와 같은 천재 지변이나 테러, 해킹, 사이버 공격 등 각종 재난, 재해로 인해 데이터센터의 IT 인프라 장애가 발생하여 제 기능을 수행하지 못하게 되었을 때, 이를 빠르게 대체하거나 복구하여 비즈니스 및 서비스의 연속성을 확보합니다.',
        name: 'DR(Disaster Recovery)',
        img: '/img/tech/ft-2.jpg',
        bg: '/img/tech/ft-2-m.jpg',
      },
      {
        title: '산불 대비 방수총',
        body: '데이터센터 건물 옥상에 설치된 방수총은 화재 발생 시 방수거리 60 m 내의 물을 부챗살 형태로 분사하여 데이터센터로 번지는 불을 막아 내도록 설계되었습니다.',
        img: '/img/tech/ft-3.jpg',
        bg: '/img/tech/ft-3-m.jpg',
      },
    ],
  },
];
